"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var NotificationContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationContainer, _Component);

  var _super = _createSuper(NotificationContainer);

  function NotificationContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      currentNotification: _this.props.notification
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onRemove", function () {
      _this._notificationQueue.shift(); // clear the state first so that it causes a re-render and the queue can be re-checked


      _this.setState({
        currentNotification: null
      });
    });
    var notification = props.notification;
    _this._notificationQueue = [];

    if (notification) {
      _this._notificationQueue.push(notification);
    }

    return _this;
  }

  (0, _createClass2.default)(NotificationContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          notification = _this$props.notification,
          onQueueEmpty = _this$props.onQueueEmpty;

      this._checkQueue();

      if (prevState.currentNotification && !this.state.currentNotification && !this._notificationQueue.length && onQueueEmpty) {
        onQueueEmpty();
      } else if (notification && !(0, _find.default)(this._notificationQueue, {
        id: notification.id
      }) // eslint-disable-line react/prop-types
      ) {
          // eslint-disable-line react/prop-types
          this._notificationQueue.push(notification);

          this._checkQueue();
        }
    }
  }, {
    key: "_checkQueue",
    value: function _checkQueue() {
      if (this.state.currentNotification || !this._notificationQueue.length) {
        return;
      }

      this.setState({
        currentNotification: this._notificationQueue[0]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var currentNotification = this.state.currentNotification;
      var classes = (0, _classnames.default)('NotificationContainer', className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, currentNotification && /*#__PURE__*/_react.default.createElement(_Notification.default, (0, _extends2.default)({
        onRemove: this._onRemove
      }, currentNotification)));
    }
  }]);
  return NotificationContainer;
}(_react.Component);

exports.default = NotificationContainer;